import { getPassOffers, IGetPassOfferRequestPayload, IPassOfferResponse } from "../../../app/api/getPassOffers";
import { ISO_FULL_DATE_FORMAT_NO_TZ } from "../../../config/global";
import { BaseAction } from "../../../core/actions/BaseAction";
import { uuid } from "../../../core/utils/Uuid";
import { determineDefaultAge, getPassengerCard } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PassengerPrmNeedTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { ICmsMonthlyPassOffer, ICmsTravelPassOffer } from "../../../Orchestrator/Types/Interface/ICMSOffers";
import dayjs from "dayjs";

class GetPassOffersAction extends BaseAction<IPassOfferResponse | null, {
  selectedCmsPassOfferAtom: ICmsMonthlyPassOffer | ICmsTravelPassOffer | null,
  startDate: dayjs.Dayjs,
  passengerType: string
}> {
  override async run(): Promise<IPassOfferResponse | null> {
    let result: IPassOfferResponse | null = null;

    try {
      const { selectedCmsPassOfferAtom, startDate, passengerType } = this.params!;

      if (!selectedCmsPassOfferAtom) {
        console.error("No selected pass offer found");
        return null;
      }

      let payload: IGetPassOfferRequestPayload = {
        "nonTripSearchCriteria": {
          "validFrom": dayjs(startDate.toString()).format(ISO_FULL_DATE_FORMAT_NO_TZ) + ".000",
          "places": [
            {
              "stopPlaceRef": selectedCmsPassOfferAtom.origin.code,
              "objectType": "StopPlaceRef"
            },
            {
              "stopPlaceRef": selectedCmsPassOfferAtom.destination.code,
              "objectType": "StopPlaceRef"
            }
          ]
        },
        "offerSearchCriteria": {
          "productTags": [],
          "offerMode": "INDIVIDUAL",
          "currency": "AED"
        },
        "anonymousPassengerSpecifications": [{
          externalRef: uuid(),
          age: determineDefaultAge(passengerType),
          type: 'PERSON',
          cards: getPassengerCard(passengerType),
          ...(passengerType === "wheelchair" ? {
            prmNeeds: [PassengerPrmNeedTypeEnum.Wheelchair]
          } : {})
        }]
      }

      const response = await getPassOffers(payload);
      if (response.status === "ok" && response.answer) {
        result = response.answer;
      }
    } catch {
      console.error("Failed to fetch pass offers");
    } finally {
      updateRecoilState("passOfferResponseAtom", result);
      return result;
    }
  }
}

export const getPassOffersAction = new GetPassOffersAction();
